import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import Accordion from '../../../components/Accordion/Accordion';
import FilterItem from './FilterItem';
import { BG_GRAY } from '../../../styles/variables.style';

const FiltersWrapper = styled.div`
  padding: 15px 0;
  background-color: ${BG_GRAY.COMMON_1};
`;

class MobileDropdown extends React.Component {
  static defaultProps = {
    title: undefined,
  };

  static propTypes = {
    active: PropTypes.arrayOf(PropTypes.string).isRequired,
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    onUpdate: PropTypes.func.isRequired,
    options: PropTypes.arrayOf(PropTypes.string).isRequired,
    title: PropTypes.string,
  };

  handleListItemClicked = (label, selected) => {
    const { active, id, onUpdate } = this.props;
    let newActive;
    if (label === 'All') {
      newActive = [];
    } else if (selected) {
      newActive = active.filter(option => option !== label);
    } else {
      newActive = active.concat(label);
    }
    onUpdate(newActive, id);
  };

  render = () => {
    const { active, label, options, title } = this.props;

    return (
      <Accordion
        title={label}
        key={title}
        contentHeight={(options.length + 1) * 45 + 30 /* FilterWrapper padding + FilterItem height */}
      >
        <FiltersWrapper>
          <FilterItem label="All" onClick={this.handleListItemClicked} selected={active.length === 0} />

          {options.map(option => (
            <FilterItem
              key={option}
              label={option}
              onClick={this.handleListItemClicked}
              selected={active.indexOf(option) >= 0}
            />
          ))}
        </FiltersWrapper>
      </Accordion>
    );
  };
}

export default MobileDropdown;



// WEBPACK FOOTER //
// ./src/components/DropdownMenu/MobileDropdown/MobileDropdown.js